import React from 'react';
import { OpenLogin } from '../../SignupLogin';
import { Container, Row, Col, Button } from 'reactstrap';
import { T } from '../../../traks';

export const NotLoggedIn = () => {
    return (
        <Container className="checkout-login-container">
          <Row>
            <Col>
              <span><T>You need to be logged in to checkout</T></span>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button onClick={OpenLogin}><T>Login</T></Button>
            </Col>
          </Row>
        </Container>
    )
}


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Checkout/NotLoggedIn.js